import React, { forwardRef } from "react";
import icons, { IconsId } from "@silversea-ssc/design-system-icons";
import svgFile from "@silversea-ssc/design-system-icons/dist/svg-sprite.svg";
import styles from "./Icon.module.scss";
import clsx from "clsx";

export type IconName = IconsId;
export interface IconProps {
  name: IconName;
  className?: string;
  wrapperClassName?: string;
  size?: "0.5x" | "1x" | "1.5x" | "2x" | "2.5x" | "3x" | "4x";
  padding?: "small" | "medium" | "large" | "inline" | "inline-right" | false;
  ariaHidden?: boolean;
  strokeWidth?: number;
}

const iconNames = Object.keys(icons);
export type Ref = HTMLSpanElement;

export const IconBase: React.ForwardRefRenderFunction<Ref, IconProps> = (
  {
    name,
    className,
    wrapperClassName,
    size = "1x",
    padding = "medium",
    ariaHidden,
    strokeWidth = 0
  },
  ref
) => {
  if (!iconNames.includes(name)) return null;

  return (
    <span className={clsx(styles.wrapper, wrapperClassName)} ref={ref}>
      <svg
        aria-hidden={ariaHidden}
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={strokeWidth}
        //viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          {
            [styles.iconContainer]: true,
            [styles.paddingInline]: padding == "inline",
            [styles.paddingInlineRight]: padding == "inline-right",
            [styles.paddingSmall]: padding == "small",
            [styles.paddingMedium]: padding == "medium",
            [styles.paddingLarge]: padding == "large",
            [styles.size05X]: size == "0.5x",
            [styles.size1X]: size == "1x",
            [styles.size15X]: size == "1.5x",
            [styles.size2X]: size == "2x",
            [styles.size25X]: size == "2.5x",
            [styles.size3X]: size == "3x",
            [styles.size4X]: size == "4x"
          },
          className
        )}
      >
        <use href={`${svgFile}#svg--${name}`} />
      </svg>
    </span>
  );
};

export const Icon = forwardRef(IconBase);
